import { DateTimeIso8601_Schema, NaturalNumber_Schema } from "@/utilities/schema";
import { z } from "zod";

// For some unknown reason, API sometimes sends ID as number and sometimes as string
export const ThemeId_Schema = z.union([NaturalNumber_Schema, z.string()]);

export const Theme_Schema = z.object({
  id: ThemeId_Schema,
  name: z.string(),
  // Webalized parent-chained theme name; the value usable as the `theme` catalogue filter (?theme=<slug>).
  // Optional/empty for payloads or documents indexed before the field existed — callers gate on it.
  slug: z.string().nullish(),
  release: DateTimeIso8601_Schema.nullable(),
  symbol: z.url().nullable(),
});
